import OverlayTips from "../OverlayTips";

function ReportsDashboardPageOverlayTipsManager()
{
    PageOverlayTipsManager.call(this);
}

ReportsDashboardPageOverlayTipsManager.prototype = _.create(PageOverlayTipsManager.prototype, {
    addBaseTips: function()
    {
        PageOverlayTipsManager.prototype.addBaseTips.apply(this);

        this.add($("td.pagetitle"), {
            messageKey: "tips.reports_dashboard.title",
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: 30,
            offsetY: -10,
            outside: {
                direction: OverlayTips.DIRECTION_TOP_RIGHT,
                offsetX: -230,
                offsetY: 0
            }
        });

        this.add($(".createChart"), {
            messageKey: "tips.reports_dashboard.chart",
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: -65,
            offsetY: 4
        });

        this.add($(".createReportDropdownButton"), {
            messageKey: "tips.reports_dashboard.new_report",
            direction: OverlayTips.DIRECTION_TOP_RIGHT,
            offsetX: 10,
            offsetY: -20
        });
    }
});

export default ReportsDashboardPageOverlayTipsManager;


// WEBPACK FOOTER //
// ./web/js/tips/managers/ReportsDashboardPageOverlayTipsManager.js